/**
 * Export the current version.
 */
export const VERSION = require('../package.json').version
